/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Delivered_30d_HintInputs */

const en_metric_delivered_30d_hint = /** @type {(inputs: Metric_Delivered_30d_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed in last 30 days`)
};

const es_metric_delivered_30d_hint = /** @type {(inputs: Metric_Delivered_30d_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completados en los ultimos 30 dias`)
};

/**
* | output |
* | --- |
* | "Completed in last 30 days" |
*
* @param {Metric_Delivered_30d_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_delivered_30d_hint = /** @type {((inputs?: Metric_Delivered_30d_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Delivered_30d_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_delivered_30d_hint(inputs)
	return es_metric_delivered_30d_hint(inputs)
});